import { createContext } from 'react'

export const DropdownContext = createContext({})
export const DropdownProvider = DropdownContext.Provider
